import { getLocalizedText } from '../../../src/server/lib/getLocalizedText';
import { ChannelErrorDef } from '../types/types';

export function matchErrors(
    channelErrorDefs: ChannelErrorDef[] | null | undefined,
    errorMessages: string[] | null | undefined,
    locale: string,
    matchedChannelErrorDef?: ChannelErrorDef,
    flow?: Flow,
    channel?: Channel,
): {
    matchingChannelErrorDefs: ChannelErrorDef[];
    channelErrorMessage?: string;
    channelErrorField: string;
    realTitle?: string;
    realDescription?: string;
    realResolution?: string;
    channelErrorParams?: RegExpExecArray;
} {
    let channelErrorMessage: string | undefined;
    let channelErrorField: string = '';
    let matchingChannelErrorDefs: ChannelErrorDef[] = [];
    let realTitle: string | undefined;
    let realDescription: string | undefined;
    let realResolution: string | undefined;
    let channelErrorParams: RegExpExecArray | undefined;

    if (!channelErrorDefs) {
        channelErrorDefs = [];
    }

    if (!errorMessages) {
        errorMessages = [];
    }

    errorMessages = errorMessages.map((a: string) => String(a || '').trim()).filter((a: string) => !!a);
    outer: for (let row of channelErrorDefs) {
        if (!row || !row.regexps) {
            continue;
        }

        let regexps: string[] = row.regexps.split("\n").map((a: string) => a.trim()).filter((a: string) => !!a);

        for (let regexp of regexps) {
            if (regexp) {
                let fieldNames: string[] = (row.fieldNames || "").split("\n").map((a: string) => a.trim()).filter((a: string) => !!a);
                if (fieldNames.length === 0) {
                    fieldNames = [""];
                }

                for (let fieldName of fieldNames) {

                    for (let errorMessage of errorMessages) {
                        if (!errorMessage) {
                            continue;
                        }

                        if (errorMessage.includes(regexp)) {
                            matchingChannelErrorDefs.push(row);

                            realTitle = getLocalizedText(row.title || row.name || '', locale);
                            realDescription = getLocalizedText(row.description || '', locale);
                            realResolution = getLocalizedText(row.resolution || '', locale);

                            continue outer;
                        }
                        try {
                            let re = new RegExp(regexp + (fieldName ? ".*" + fieldName : ""), "gmi");
                            let res = re.exec(errorMessage);

                            if (res && res.length > 0) {
                                channelErrorMessage = res[0];
                                channelErrorField = fieldName;

                                realTitle = getLocalizedText(row.title || row.name || '', locale);
                                realDescription = getLocalizedText(row.description || '', locale);
                                realResolution = getLocalizedText(row.resolution || '', locale);

                                channelErrorParams = res;

                                for (let i = 1; i < 20; i++) {
                                    let value: string = "XXX";
                                    if (res[i]) {
                                        value = res[i];
                                    }

                                    realTitle = realTitle.replace(new RegExp("\\$" + i, "gm"), value);
                                    realDescription = realDescription.replace(new RegExp("\\$" + i, "gm"), value);
                                    realResolution = realResolution.replace(new RegExp("\\$" + i, "gm"), value);
                                }

                                matchingChannelErrorDefs.push(row);
                                continue outer;
                            }
                        } catch (e) {
                            console.error(e);
                            /* ignore */
                        }
                    }
                }
            }
        }
    }

    if (matchingChannelErrorDefs.length === 0 && matchedChannelErrorDef) {
        let row = matchedChannelErrorDef;
        matchingChannelErrorDefs.push(row);
        realTitle = getLocalizedText(row.title || row.name || '', locale);
        realDescription = getLocalizedText(row.description || '', locale);
        realResolution = getLocalizedText(row.resolution || '', locale);
    }

    return {matchingChannelErrorDefs, channelErrorMessage, channelErrorField, realTitle, realDescription, realResolution, channelErrorParams};
}